/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

/**
 * Resolves promise after timeout
 *
 * @param timeout Timeout (milliseconds)
 */
export function timeoutPromise(timeout: number) {

	return new Promise((resolve, _reject) => {

		setTimeout(() => resolve(), timeout);

	});

}
